import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RxIEDetectionComponent } from './rx-ie-detection.component';
import { RxIEDetectionRoutingModule } from './rx-ie-detection-routing.module';

@NgModule({
  imports: [CommonModule, RxIEDetectionRoutingModule, RxIEDetectionComponent],
  exports: [RxIEDetectionComponent],
})
export class RxIEDetectionModule {}
